<div class="horizontal-sidebar p-y-8 b-b-1">
  <div class="container">
    <div>
      <div class="horizontal-navbar hstack align-items-center">
        horizontal menu here
      </div>
    </div>
  </div>
</div>
